export default "__VITE_ASSET__D01nPGty__"